import React from 'react';
import { Outlet } from 'react-router-dom';
import { AuthContext, AuthData } from '../../context/auth';
import { ClaimContext, ClaimData } from '../../context/claim';
import { ConfigData } from '../../context/config';
import { PolicyContext, PolicyData } from '../../context/policy';
import {
	StyledSectionContainer,
	StyledTitle,
	StyledTitleContainer,
} from '../common';
import AddSubclaimModal from './AddSubclaimModal';
import SubclaimsTable from './SubclaimsTable';

interface Props {
	authData: AuthData;
	claimData: ClaimData;
	policyData: PolicyData;
	configData: ConfigData;
}

const SubclaimsView = (props: Props) => {
	const { claimData, authData } = props;

	const canOpenSubclaim =
		authData.hasPermission('claim.update') &&
		claimData.claim.currentStatus !== 'closed';
	return (
		<>
			<StyledTitleContainer>
				<StyledTitle>Subclaims</StyledTitle>
				{canOpenSubclaim && <AddSubclaimModal />}
			</StyledTitleContainer>
			<hr />
			<StyledSectionContainer>
				<SubclaimsTable />
			</StyledSectionContainer>
			<Outlet />
		</>
	);
};

function withContext(Component: any) {
	return (
		props: Omit<Props, 'authData' | 'claimData' | 'policyData' | 'configData'>,
	) => (
		<AuthContext.Consumer>
			{(authData) => (
				<PolicyContext.Consumer>
					{(policyData) => (
						<ClaimContext.Consumer>
							{(claimData) => (
								<Component
									{...props}
									authData={authData}
									policyData={policyData}
									claimData={claimData}
								/>
							)}
						</ClaimContext.Consumer>
					)}
				</PolicyContext.Consumer>
			)}
		</AuthContext.Consumer>
	);
}

export default withContext(SubclaimsView);
